import { makeAutoObservable } from 'mobx';

class ProductStore {
	productId: string | null = null;

	constructor() {
		makeAutoObservable(this);
	}

	setProductId = (state: string) => {
		this.productId = state;
	};
}

const productStore = new ProductStore();
export default productStore;
